import { FilterListGlobalForm } from 'common/pages/filter-list-global/FilterListGlobalForm.tsx'

export const FilterListGlobalFormAdvertiser = (props: any) => <FilterListGlobalForm {...props} mode={props.mode} />
